'use strict';

/**
 * Customer -> Sales Agent report: every acquired customer with its sales agent and the agent's status
 * (Active / Inactive; inactive is highlighted). A filter shows only the customers of inactive agents.
 * ADMIN can reassign a customer by hand to an ACTIVE agent; nothing is ever reassigned automatically.
 * Every change of agent is kept in the Sales API's assignment history (read only, shown per customer).
 */
angular.module('scrapQcrmApp')
    .controller('CustomerSalesAgentReportCtrl', function ($scope, tableState, $rootScope, $global, $uibModal, $moment, growl, authentication, dashboard, salesAgentService) {

        $rootScope.loginData = $global.getLocalItem("loginData", true);
        $scope.canReassign = $rootScope.loginData && $rootScope.loginData.role === 'ADMIN';
        $scope.access = 'checking'; // checking | granted | denied
        $scope.loading = false;
        $scope.loadError = false;
        $scope.rows = [];
        $scope.counts = { total: null, ACTIVE: null, INACTIVE: null, UNASSIGNED: null, NOT_FOUND: null };
        $scope.statusFilter = 'all';
        $scope.search = { text: '' }; // an object: the search box sits inside ng-if (a child scope)
        $scope.activeAgents = [];

        $scope.statusTiles = [
            { key: 'all', label: 'All Customers' },
            { key: 'ACTIVE', label: 'Active Agent' },
            { key: 'INACTIVE', label: 'Inactive Agent' },
            { key: 'UNASSIGNED', label: 'No Agent' },
            { key: 'NOT_FOUND', label: 'Agent Not Found' }
        ];
        var STATUS_TEXT = { ACTIVE: 'Active', INACTIVE: 'Inactive', UNASSIGNED: 'No agent', NOT_FOUND: 'Agent not found' };

        // ---------- grid ----------

        function escapeHtml(text) {
            return String(text === undefined || text === null ? '' : text)
                .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
        }

        function StatusRenderer() {
        }
        StatusRenderer.prototype.init = function (params) {
            this.eGui = document.createElement('span');
            var status = params.data ? params.data.agentStatus : '';
            var cls = status === 'ACTIVE' ? 'label-success' : (status === 'INACTIVE' ? 'label-danger' : 'label-default wh-status-inactive');
            this.eGui.className = 'label ' + cls;
            this.eGui.textContent = STATUS_TEXT[status] || status || '';
        };
        StatusRenderer.prototype.getGui = function () {
            return this.eGui;
        };

        function ActionsRenderer() {
        }
        ActionsRenderer.prototype.init = function (params) {
            this.eGui = document.createElement('div');
            this.eGui.innerHTML = '<button type="button" class="btn btn-link btn-xs csa-history" title="Assignment history"><i class="fa fa-history"></i> History</button>' +
                ($scope.canReassign ? ' <button type="button" class="btn btn-xs csa-reassign" title="Reassign to an active sales agent">Reassign</button>' : '');
        };
        ActionsRenderer.prototype.getGui = function () {
            return this.eGui;
        };

        $scope.gridOptions = {
            columnDefs: [
                { headerName: "Customer", field: "customerName", minWidth: 180 },
                { headerName: "Contact Person", field: "contactName" },
                { headerName: "Mobile", field: "mobileNo" },
                { headerName: "Category", field: "category" },
                {
                    headerName: "Approved", field: "isApproved", maxWidth: 120,
                    valueFormatter: function (params) { return params.value ? 'Yes' : 'No'; }
                },
                {
                    headerName: "Sales Agent", field: "agent.name", colId: "salesAgentName",
                    valueFormatter: function (params) { return params.value || '-'; }
                },
                { headerName: "Agent Mobile", field: "agent.mobileNo", colId: "salesAgentMobile" },
                {
                    headerName: "Agent Status", field: "agentStatus", maxWidth: 160, cellRenderer: StatusRenderer,
                    filterValueGetter: function (params) { return STATUS_TEXT[params.data.agentStatus]; }
                },
                {
                    headerName: "", colId: "actions", minWidth: 170, maxWidth: 190, cellRenderer: ActionsRenderer,
                    sortable: false, filter: false, suppressMenu: true
                }
            ],
            defaultColDef: { flex: 1, minWidth: 120, filter: true, sortable: true, resizable: true },
            rowData: [],
            pagination: true,
            paginationPageSize: 50,
            rowClassRules: {
                'csa-inactive-row': function (params) { return params.data && params.data.agentStatus === 'INACTIVE'; }
            },
            isExternalFilterPresent: function () {
                return $scope.statusFilter !== 'all';
            },
            doesExternalFilterPass: function (node) {
                return node.data.agentStatus === $scope.statusFilter;
            },
            overlayNoRowsTemplate: '<span class="text-muted">No customers for this filter</span>',
            onGridReady: function (params) {
                params.api.setRowData($scope.rows);
                applySearch();
            },
            onCellClicked: function (event) {
                if (event.column.getColId() !== 'actions' || !event.data || !event.event || !event.event.target) {
                    return;
                }
                var target = angular.element(event.event.target);
                if (target.closest('.csa-history').length) {
                    $scope.$applyAsync(function () { $scope.openHistory(event.data); });
                } else if (target.closest('.csa-reassign').length && $scope.canReassign) {
                    $scope.$applyAsync(function () { $scope.openReassign(event.data); });
                }
            }
        };

        function applySearch() {
            if ($scope.gridOptions.api) {
                $scope.gridOptions.api.setQuickFilter($scope.search.text || '');
            }
        }
        function applyStatusFilter() {
            if ($scope.gridOptions.api) {
                $scope.gridOptions.api.onFilterChanged();
            }
        }

        $scope.setStatusFilter = function (key) {
            $scope.statusFilter = key;
            applyStatusFilter();
        };
        $scope.searchChanged = function () {
            applySearch();
        };
        $scope.shownCount = function () {
            return $scope.gridOptions.api ? $scope.gridOptions.api.getDisplayedRowCount() : 0;
        };
        $scope.downloadExcel = function () {
            $rootScope.downloadReportExcel($scope.gridOptions, 'Customer_Sales_Agent_Report', 'all', 'all');
        };

        // ---------- data ----------

        var subAreas = null;
        function getSubAreas() {
            if (subAreas) {
                return Promise.resolve(subAreas);
            }
            return dashboard.getAllCity().then(function (res) {
                var list = [];
                if (res && res.status === 'SUCCESS' && res.data && res.data.cities) {
                    res.data.cities.forEach(function (elem) {
                        if (elem.name === $rootScope.loginData.city && list.indexOf(elem.subarea) < 0) {
                            list.push(elem.subarea);
                        }
                    });
                }
                subAreas = list;
                return list;
            });
        }

        $scope.load = function () {
            $scope.loading = true;
            $scope.loadError = false;
            getSubAreas().then(function (areas) {
                return Promise.all([salesAgentService.customerAgentsReport(areas, ''), salesAgentService.getAllSalesAgents(true)]);
            }).then(function (results) {
                var report = results[0], agents = results[1];
                if (!report || report.status !== 'Success') {
                    throw new Error((report && report.message) || 'report failed');
                }
                $scope.$applyAsync(function () {
                    $scope.rows = report.data || [];
                    $scope.counts = report.counts || $scope.counts;
                    $scope.counts.all = $scope.counts.total;
                    $scope.activeAgents = agents && agents.status === 'Success' ? (agents.data || []).filter(function (a) {
                        return a.enabled !== false;
                    }).map(function (a) {
                        return { userId: String(a.userId), name: a.name, mobileNo: a.mobileNo };
                    }).sort(function (a, b) {
                        return String(a.name).localeCompare(String(b.name));
                    }) : [];
                    $scope.loading = false;
                    if ($scope.gridOptions.api) {
                        $scope.gridOptions.api.setRowData($scope.rows);
                        applySearch();
                    }
                });
            }).catch(function (err) {
                console.error('Error loading the customer -> sales agent report', err);
                $scope.$applyAsync(function () {
                    $scope.loading = false;
                    $scope.loadError = true;
                });
            });
        };

        // ---------- reassign (manual, active agents only) ----------

        $scope.openReassign = function (row) {
            if (!$scope.canReassign) {
                return;
            }
            var modal = $uibModal.open({
                templateUrl: 'views/customer-salesagent-reassign-modal.html',
                size: 'md',
                backdrop: 'static',
                controller: ['$scope', '$uibModalInstance', function ($m, $uibModalInstance) {
                    $m.row = row;
                    $m.statusText = STATUS_TEXT;
                    // the current agent is not offered again (reassigning to the same agent changes nothing)
                    $m.agents = $scope.activeAgents.filter(function (a) {
                        return !row.agent || a.userId !== row.agent.userId;
                    });
                    $m.choice = { agent: null };
                    $m.saving = false;
                    $m.error = null;
                    $m.save = function () {
                        if (!$m.choice.agent || $m.saving) {
                            return;
                        }
                        $m.saving = true;
                        $m.error = null;
                        salesAgentService.reassignCustomerAgent(row.leadId, $m.choice.agent.userId, row.agent ? row.agent.userId : "").then(function (res) {
                            $m.saving = false;
                            if (res && res.status === 'Success') {
                                $uibModalInstance.close(res.data);
                            } else {
                                $m.error = (res && res.message) || 'Could not reassign the customer';
                                $m.changedElsewhere = !!(res && res.message && res.message.indexOf('someone else') >= 0);
                            }
                        }, function () {
                            $m.saving = false;
                            $m.error = 'Could not reach the sales server. Try again.';
                        });
                    };
                    $m.cancel = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                }]
            });
            modal.result.then(function (data) {
                growl.success(row.customerName + ' is now assigned to ' + data.agent.name);
                $scope.load(); // counts and statuses change
            }, function (reason) {
                if (reason === 'reload') {
                    $scope.load();
                }
            });
        };

        // ---------- history (read only) ----------

        $scope.openHistory = function (row) {
            $uibModal.open({
                templateUrl: 'views/customer-salesagent-history-modal.html',
                size: 'lg',
                controller: ['$scope', '$uibModalInstance', function ($m, $uibModalInstance) {
                    $m.row = row;
                    $m.loading = true;
                    $m.error = null;
                    $m.entries = [];
                    $m.actionText = {
                        REASSIGN: 'Reassigned', ASSIGN: 'Assigned', UNASSIGN: 'Unassigned',
                        AGENT_DISABLED: 'Unassigned (agent disabled)', UPDATE: 'Changed'
                    };
                    $m.when = function (date) {
                        return date ? $moment(date).format('DD-MMM-YYYY hh:mm A') : '';
                    };
                    salesAgentService.customerAssignmentHistory(row.leadId).then(function (res) {
                        $m.loading = false;
                        if (res && res.status === 'Success') {
                            $m.entries = res.data || [];
                        } else {
                            $m.error = (res && res.message) || 'Could not load the history';
                        }
                    }, function () {
                        $m.loading = false;
                        $m.error = 'Could not reach the sales server. Try again.';
                    });
                    $m.close = function () {
                        $uibModalInstance.dismiss('close');
                    };
                }]
            });
        };

        // filter and search in the URL (Back / refresh keep them)
        tableState.page($scope, 'cs', {
            controls: {
                s: {
                    model: 'statusFilter', type: 'string',
                    validate: function (v) { return ['all', 'ACTIVE', 'INACTIVE', 'UNASSIGNED', 'NOT_FOUND'].indexOf(v) >= 0; },
                    onRestore: function () { applyStatusFilter(); }
                },
                q: { model: 'search.text', type: 'string', history: 'search', onRestore: function () { applySearch(); } }
            },
            grids: { g: 'gridOptions' }
        });

        // the report needs the updated Sales API (see salesApiUpdated in app.js)
        if (!$global.salesApiUpdated) {
            $scope.access = 'unavailable';
            return;
        }

        // the page is only for the roles that have the report
        authentication.getUserRoleMetrics({
            city: $rootScope.loginData.city,
            userType: $rootScope.loginData.role,
            module: "Reports",
            subModule: "CustomerSalesAgent",
            type: "Other"
        }).then(function (res) {
            var granted = res && res.status === 'SUCCESS' && res.data && res.data.userRoleMatrix && res.data.userRoleMatrix.length > 0;
            $scope.access = granted ? 'granted' : 'denied';
            if (granted) {
                $scope.load();
            }
        }).catch(function () {
            $scope.access = 'denied';
        });
    });
